import SummaryItem from './SummaryItem'

export type { SummaryItemProps } from './SummaryItem'

export default SummaryItem
